import { useEffect, useState } from "react";

/*
 * Whether one of the app's windows (modals) is open: Headless UI dialogs,
 * daisyUI modals and <dialog>. Used by the Help chat button (moved here from
 * HelpChat.tsx) and by Ask ProCharted in the top search (QA batch 11: the Ask
 * panel opened over the New work window).
 */
const OPEN_DIALOG = [
  "[role=dialog][aria-modal=true]",
  ".modal.modal-open",
  ".modal-toggle:checked + .modal",
  "dialog[open]",
].join(",");

/** True while one of the app's windows (modals) is open. */
export const useOtherWindowOpen = () => {
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    let frame = 0;
    const check = () => {
      frame = 0;
      setIsOpen(!!document.querySelector(OPEN_DIALOG));
    };
    const schedule = () => {
      if (!frame) frame = window.requestAnimationFrame(check);
    };
    check();
    const observer = new MutationObserver(schedule);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "aria-modal", "open"],
    });
    document.addEventListener("change", schedule, true);
    return () => {
      observer.disconnect();
      document.removeEventListener("change", schedule, true);
      if (frame) window.cancelAnimationFrame(frame);
    };
  }, []);
  return isOpen;
};
